module.exports = __webpack_public_path__ + "static/media/7.87ad968a.jpg";